<template lang="html">
    <div class="container" v-if="show">
        <p>404 | {{ $t('default.page_not_found') }}</p>
    </div>
</template>

<script>
import { axios } from "@/helpers"

export default {
    data() {
        return {
            show: false
        }
    },
    created() {
        const protocol = window.location.protocol;
        const host = window.location.hostname;
        const port = window.location.port;
        let search = window.location.search;

        if(search == '') {
            this.show = true;

            return;
        }

        search = search.replace('#', '');
        var last = search.substr(search.length - 1);
        if(last == '/') {
            search = search.slice(0,-1);
        }

        const languages =['nl', 'fr', 'en'];
        const parts = search.split('/');
        let lang = parts.at(1);
        let param = parts.at(2);
        let site_id = parts.at(3);

        if(! languages.includes(lang) || isNaN(site_id) || param != 'contact') {
            this.show = true;

            return;
        }

        axios
            .get('/' + lang + '/slug/' + site_id)
                .then(response => {
                    if(typeof response?.data?.success !== "undefined") {
                        const country = response.data.success.country;
                        const slug = response.data.success.slug;

                        switch (lang) {
                            case 'fr':
                            case 'en':

                                break;
                            case 'nl':
                                lang = country == 'BE' ? "nl_BE" : "nl_NL";

                                break;
                        }

                        window.location = protocol + "//" + host + (port ? ":" + port : "") + "/#/" + lang + "/" + slug;

                        return;
                    }

                    this.show = true;
                }).catch(()  => {
                    this.show = true;
                });
    },
}
</script>

